module.exports = __webpack_public_path__ + "static/media/animated_ashutosh.acd4edb9.png";